import React from 'react'

import IconCabel from 'assets/icons/Cabel.png'
import IconIPTV from 'assets/icons/IPTV.png'
import IconTV from 'assets/icons/Kion.png'
import IconSputnik from 'assets/icons/Sputnik.png'

import classes from './Priority.module.scss'
import { useWindowSize } from 'shared/hooks/useWindowSize'
import { scrollIntoElement } from 'shared/utils'
import { HomeOriginalsBlockID } from '../Originals/Originals'

export const Priority = (): JSX.Element => {
  const { isMobile } = useWindowSize()

  const items = [
    {
      icon: IconTV,
      hash: HomeOriginalsBlockID,
      title: 'KION',
      descr:
        'Онлайн-кинотеатр с оригинальным контентом, фильмами и телеканалами, доступный на любом устройстве',
    },
    {
      icon: IconSputnik,
      link: 'https://sputnik.mts.ru/',
      title: 'Спутниковое ТВ',
      descr:
        'Более 200 телеканалов в высоком качестве 4K и HD, доступные даже там, где нет интернета',
    },
    {
      icon: IconCabel,
      link: 'https://moskva.mts.ru/personal/dom',
      title: 'Кабельное ТВ',
      descr: 'Широкий выбор телеканалов по доступным тарифам у вас дома',
    },

    {
      icon: IconIPTV,
      link: 'https://mts-gpon.ru/',
      title: 'IPTV',
      descr:
        'Телевидение с интерактивными функциями и встроенным онлайн-кинотеатром KION',
    },
  ]

  const renderIcon = (icon: any, link?: string, hash?: string) => {
    const img = <img src={icon} alt="icon" />

    if (link) {
      return (
        <a href={link} target="_blank" rel="noreferrer">
          {img}
        </a>
      )
    }

    if (hash) {
      return (
        <a
          href={`#${hash}`}
          onClick={ev => {
            ev.preventDefault()
            scrollIntoElement(hash)
          }}
        >
          {img}
        </a>
      )
    }

    return img
  }

  return (
    <div className={classes.wrap}>
      <div className="container">
        <h2
          className="reveal-from-bottom-large second-title"
          data-reveal-delay={30}
        >
          KION
        </h2>
        <div
          className={`reveal-from-bottom-large ${classes.description}`}
          data-reveal-delay={30}
        >
          Мы не только продюсируем и создаем оригинальный развлекательный
          контент,{isMobile ? '' : <br />} но и развиваем сервисы для просмотра
          фильмов и сериалов в каждом доме и на любом устройстве:
        </div>
        {/*<NavLink to="/catalog" className={classes.btn_link}>
          <Button className="reveal-from-bottom-large" data-reveal-delay={30}>
            Наши проекты
          </Button>
        </NavLink>*/}
        <div className={`${classes.items} row`}>
          {items.map((item, itemIndex) => {
            return (
              <div
                key={itemIndex}
                className={`${classes.items__item} col-xs-12 col-sm-6 col-lg-3 reveal-from-bottom-medium`}
                data-reveal-delay={(itemIndex + 1) * 100}
              >
                {renderIcon(item.icon, item?.link, item?.hash)}
                <div className={classes.title}>{item.title}</div>
                <div className={classes.descr}>{item.descr}</div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
